import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { MainScene } from "./scenes/MainScene";

interface DragDropDemoProps {
}

interface DragDropDemoState {
}

const gameConfig: GameConfig = {
    title: "Drag Drop Demo - Phaser",
    version: "4.2-demo",
    width: 768,
    height: 576,
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#3A99D9"
};

class DragDropDemo extends React.Component<DragDropDemoProps, DragDropDemoState> {
    private game: Phaser.Game;
    constructor(props: DragDropDemoProps) {
        super(props);
        bindAllOfThis(this, DragDropDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={MainScene} config={gameConfig} />
        </div>);
    }
}

export default DragDropDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserDragDropDemo/Main.tsx